import styled from 'styled-components';

const SimpleWrapper = styled.div<any>`
  height: 26px;
  position: relative;
  background-color: ${(props) => props.theme.colors.outline};
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.outline};
  cursor: pointer;
  padding: 3px 8px;
  
  select {
    height: 100%;
    color: ${(props) => props.theme.colors.text};
    font-size: 13px;
    text-align: center;
    background: ${(props) => props.theme.colors.outline};
    -webkit-appearance: auto;
    -moz-appearance: auto;

    :disabled {
      cursor: not-allowed;
      opacity: 50%;
    }
  }
  
  &:hover {
    border: ${(props) => (`1px solid ${props.theme.colors.white}`)}
  }
`;

const Wrapper = styled.div<any>`
  height: ${(props) => (props?.error ? '96px' : '74px')};
  position: relative;
  background-color: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  border: 1px solid ${(props) => props.theme.colors.outline};
  transition: all .2s ease-in;
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  border: ${(props) => (
    props.error ? `1px solid ${props.theme.colors.red}` : ` 1px solid ${props.theme.colors.widget_background}`
  )};

  &.changed-value {
    background-color: ${(props) => props.theme.colors.main_cta_light};
  }

  label {
    position: absolute;
    top: 16px;
    left: 16px;
    color: ${(props) => props.theme.colors.text};
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    pointer-events: none;
  }

  select {
    height: 100%;
    width: 100%;
    padding: 16px;
    margin-top: ${(props) => (props?.error ? '0' : '7px')};
    color: ${(props) => props.theme.colors.text};
    font-size: 13px;
    caret-color: ${(props) => props.theme.colors.main_cta};
    overflow: hidden;
    align-items: center;
    -webkit-appearance: auto;
    -moz-appearance: auto;

    ::placeholder {
      position: absolute;
      top: ${(props) => (props?.error ? '37px' : '28px')};
      color: ${(props) => props.theme.colors.inactive};
      font-size: 13px;
    }

    :disabled {
      cursor: not-allowed;
      opacity: 50%;
    }    
  }

  select option {
    // margin: 40px;
    background: ${(props) => props.theme.colors.widget_background};
    color: ${(props) => props.theme.colors.text};
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }

  select option[class="hidden"] { 
    display: none; 
  } 
  
  &:has(input:focus) {
    border: 1px solid ${(props) => props.theme.colors.main_cta};
    border-radius: 12px;
  }

  &:hover {
    border: ${(props) => (`1px solid ${props.theme.colors.white}`)}
  }
`;

const ErrorMessage = styled.p`
  position: absolute;
  padding-right: 10px;
  top: 65px;
  left: 15px;
  font-family: ManropeLight, sans-serif;
  font-size: 13px;
  text-align: right;
  color: ${(props) => props.theme.colors.red}
`;

export default { SimpleWrapper, Wrapper, ErrorMessage };
